import { Grid } from "@mui/material";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { TextInput } from "components/FormControls/TextInput";
import { Field, FieldProps } from "formik";
import { useMessage } from "hooks/intl";
import { VariableGroupsDropdown } from "../../VariableGroupsDropdown/VariableGroupsDropdown";

interface Props {
  fieldName: string;
  withKeyValue?: boolean;
}

export const CollectionsConditionValue = ({
  fieldName,
  withKeyValue,
}: Props) => {
  const { message } = useMessage();

  return (
    <Grid container spacing={12}>
      {withKeyValue ? (
        <Grid item xs={12}>
          <TextInput
            width="100%"
            name={`${fieldName}.labelKey`}
            label={
              <RequiredFieldLabel
                text={message({ id: "customAttributeKeyLabel" })}
              />
            }
            data-test-id="custom-attribute-key"
          />
        </Grid>
      ) : null}
      <Grid item xs={12}>
        <Field name={`${fieldName}.groupValuesIds`}>
          {({ field }: FieldProps) => (
            <VariableGroupsDropdown
              fieldName={`${fieldName}.groupValuesIds`}
              data-test-id="condition-value"
              placeholder={message({ id: "chooseFromTheList" })}
              value={field.value?.groupOfValues}
            />
          )}
        </Field>
      </Grid>
    </Grid>
  );
};
